










import Vue, { PropType } from 'vue';

const colorType = ['gray'];

export default Vue.extend({
  name: 'GRoundTag',
  props: {
    color: {
      type: String as PropType<string>,
      default: 'gray',
      validator: (prop: string) => colorType.includes(prop),
    },
  },
});
